// extracted by mini-css-extract-plugin
module.exports = {"products":"tO","productContainer":"uO","overFlowVisible":"vO","resultsHeading":"wO","oosMessaging":"xO"};